import yup, { cardNameValidator, imageValidator, arrayValidator, stringValidator } from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        categories: arrayValidator.min(1),
        description: stringValidator.max(300).required(),
        image: imageValidator(nullable),
        icon: imageValidator(nullable),
        characterClassId: stringValidator.required(),
        upgradeId: stringValidator.required(),
        actionId: stringValidator.required(),
        durabilities: arrayValidator.min(1, 'at lease one durability tier must be checked.'),
    });
